import { Link, useLocation } from 'react-router-dom'
import { BookOpen, FileText, Send, User, LogOut } from 'lucide-react'
import { useAuthStore } from '@/hooks/useAuth'
import { supabase } from '@/services/supabase'

export default function Navbar() {
  const { user, clearUser } = useAuthStore()
  const location = useLocation()

  const handleLogout = async () => {
    await supabase.auth.signOut()
    clearUser()
  }

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/')
  }

  return (
    <nav className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="text-xl font-bold text-primary-700">
              Literary SM
            </Link>
            
            <div className="flex space-x-6">
              <Link
                to="/"
                className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive('/') && location.pathname === '/'
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <BookOpen size={18} />
                <span>Dashboard</span>
              </Link>
              
              <Link
                to="/works"
                className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive('/works')
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <FileText size={18} />
                <span>Works</span>
              </Link>
              
              <Link
                to="/journals"
                className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive('/journals')
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <BookOpen size={18} />
                <span>Journals</span>
              </Link>
              
              <Link
                to="/submissions"
                className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive('/submissions')
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <Send size={18} />
                <span>Submissions</span>
              </Link>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-600">
              {user?.firstName ? `${user.firstName} ${user.lastName}` : user?.email}
            </span>
            
            <Link
              to="/profile"
              className={`p-2 rounded-md transition-colors ${
                isActive('/profile')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <User size={18} />
            </Link>
            
            <button
              onClick={handleLogout}
              className="p-2 rounded-md text-gray-600 hover:text-red-600 transition-colors"
            >
              <LogOut size={18} />
            </button>
          </div>
        </div>
      </div>
    </nav>
  )
}